import { render } from "./email-verification.vue?vue&type=template&id=696f1971"
import script from "./email-verification.vue?vue&type=script&lang=js"
export * from "./email-verification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__